<template>
  <div class="w-full">
    <label class="label whitespace-no-wrap md:whitespace-normal" :for="field">
      {{ label }}
      <span v-if="label===''">&nbsp;</span>
    </label>
    <div class="relative">
      <select class="text-base block appearance-none w-full bg-grey-lighter border text-grey-darker pt-2 pb-3 px-4 pr-8 rounded" :class="{'border-grey-lighter': !errors.has(field),'border-red': errors.has(field), 'field-disabled': disabled }" :id="field" :name="field" v-model="fieldModel" :disabled="disabled == 1" v-validate="validationRule">
        <option v-if="!fieldModel" value="" selected>{{ placeholder }}</option>
        <option v-for="option in formattedOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
      </select>
      <div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
        </svg>
      </div>
    </div>
    <p class="text-red text-xs italic mt-3" v-show="errors.has(field)">{{ validationMessage }}</p>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'FieldDropdown',
  inject: ['$validator'],
  props: {
    namespace: {
      type: String,
    },
    field: {
      type: String,
    },
    label: {
      type: String,
    },
    placeholder: {
      type: String,
      default: '',
    },
    validationRule: {
      default: '',
    },
    validationMessage: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    complementarySet: {
      type: Object,
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    fieldModel: {
      get() {
        const v = _.get(this.$store.state[this.namespace], this.field);
        if (v === null) {
          return '';
        }
        return v;
      },
      set(value) {
        this.$store.commit(`${this.namespace}/setField`, {
          field: this.field,
          value,
        });
        this.$emit('changed', value);
        if (this.complementarySet && this.complementarySet.field) {
          this.$store.commit(`${this.namespace}/setField`, {
            field: this.complementarySet.field,
            value: this.complementarySet.value,
          });
        }
      },
    },
    formattedOptions: function() {
      if (typeof this.options[0] === 'object') {
        return this.options;
      }
      return this.options.map(v => ({ label: v, value: v }));
    },
  },
};
</script>

<style scoped>
select {
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/FieldDropdown.vue